// import sha256 from 'crypto-js/sha256'
// import dayjs from 'dayjs'
import { useEffect } from 'react'
import { Helmet } from 'react-helmet'

import { COUNTRY_NAME } from '../../constants/countries'
import { useBoundStore } from '../../store/store'
// import { api } from '../../utils/api-client'

const METADATA = {
  'home': {
    title: 'Mejores Juegos de Deportes y Casino en Línea | Apuesta con Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY_NAME}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  'promotions': {
    title: 'Bonificación, Reembolso en Juegos de Casino | Fun88',
    desc: 'Duplicamos tu 1er depósito hasta $5,000 Pesos y hasta $11,000 Pesos de bono de bienvenida. Refiere a tus amigos y gana comisión. Con MexPlay ganas más.',
    keywords: '',
  },
  'betby': {
    title: 'Juega deportes en vivo ilimitados en línea | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY_NAME}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  'help-terminos-y-condiciones': {
    title: 'Lee los Términos y Condiciones | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY_NAME}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  'help-withdraw': {
    title: `El Casino Mas Serio de ${COUNTRY_NAME}, tu retiro en menos de 20 minutos`,
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY_NAME}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  'help-we': {
    title: 'Mejores Juegos en Línea y de Casino | Sobre Nosotros Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY_NAME}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  'bti': {
    title: 'Juega y Apuesta en Juegos de Casino en Vivo | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY_NAME}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  'help-betting-conditions': {
    title:
      'Condiciones de Apuesta, Apuesta y Juega en el Casino en Línea | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY_NAME}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  'help-affiliate-program': {
    title: 'Programa de Afiliados para Juegos de Casino en Línea | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY_NAME}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  'contact-us': {
    title: 'Juega y Apuesta en Casino en Vivo | Contáctanos Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY_NAME}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  'im': {
    title: 'Juega juegos de mensajería instantánea en vivo | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY_NAME}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  'help-privacy-notice-and-site-cookies': {
    title: 'Juegos de Casino en Línea | Política de Privacidad de Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY_NAME}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  'help-juego-responsable': {
    title: 'Reglas y Regulaciones para Deportes en Línea | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY_NAME}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  'help-refund-policy': {
    title: 'Política de Reembolso para Deportes en Línea | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY_NAME}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  'help-faq': {
    title: 'Preguntas Frecuentes para Casino en Línea y Apuestas | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY_NAME}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  'help-deposit': {
    title: 'Apuesta y Juega en el Casino en Línea | Opciones de Depósito Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY_NAME}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
  'help-betting-mechanics': {
    title: 'Reglas de Apuestas para Jugar en el Casino en Línea | Fun88',
    desc: `El Casino no.1 en Asia, ahora en ${COUNTRY_NAME}, Recibe 50 pesos de regalo sin rollover, bonificamos el 10% de todos tus depósitos.`,
    keywords: '',
  },
}

type MetaDataKey = keyof typeof METADATA

interface WebTitleProps {
  page?: string
  noIndex?: boolean
}

const WebTitle = ({ page, noIndex }: WebTitleProps) => {
  const pageAssertion = page as MetaDataKey
  // const email = useBoundStore(state => state.user.email)
  // const phone = useBoundStore(state => state.user.phone)
  // const userId = useBoundStore(state => state.user.userID)
  // const birthday = useBoundStore(state => state.user.birthday)
  // const firstName = useBoundStore(state => state.user.first_name)
  // const lastName = useBoundStore(state => state.user.last_name)
  const isUserLoading = useBoundStore(state => state.user.isLoading)

  useEffect(() => {
    if (isUserLoading) return
    // api.fbGraph({
    //   data: [
    //     {
    //       action_source: 'website',
    //       event_id: 12340,
    //       event_name: 'ViewContent',
    //       event_time: dayjs().unix(),
    //       user_data: {
    //         em: [email ? sha256(email).toString() : null],
    //         ph: [phone ? sha256(phone).toString() : null],
    //         client_user_agent: navigator.userAgent,
    //         external_id: [userId ? sha256(userId).toString() : null],
    //         db: [birthday ? sha256(birthday).toString() : null],
    //         fn: [firstName ? sha256(firstName).toString() : null],
    //         ln: [lastName ? sha256(lastName).toString() : null],
    //       },
    //       custom_data: {
    //         page,
    //       },
    //     },
    //   ],
    // })

    ttq?.page()
    fbq?.('track', 'ViewContent', {
      content_type: page,
    })
  }, [isUserLoading])

  if (!page || !METADATA[pageAssertion]) {
    return (
      <Helmet>
        <title>{METADATA.home.title}</title>
        <meta name="description" content={METADATA.home.desc} />
        {noIndex && <meta name="robots" content="noindex" />}
      </Helmet>
    )
  }

  return (
    <Helmet>
      <title>{METADATA[pageAssertion].title}</title>
      {page && (
        <meta name="description" content={METADATA[pageAssertion].desc} />
      )}
      {page && METADATA[pageAssertion].keywords && (
        <meta name="keywords" content={METADATA[pageAssertion].keywords} />
      )}
      {noIndex && <meta name="robots" content="noindex" />}
    </Helmet>
  )
}

export default WebTitle
